import { gql } from "@apollo/client";

export const CAMPAIGN_FIELDS_FOR_LIST = gql`
  fragment CampaignFieldsForList on Campaign {
    id
    created_at
    name
    status
    pinned
    createdByAdmin {
      id
      fullName
    }
  }
`;

export const LIST_CAMPAIGNS = gql`
  ${CAMPAIGN_FIELDS_FOR_LIST}
  query listCampaigns(
    $filter: CampaignFilterInput
    $sort: CampaignSortInput
    $limit: Int
    $offset: Int
    $subaccountId: ID!
  ) {
    listCampaigns(
      filter: $filter
      sort: $sort
      limit: $limit
      offset: $offset
      subaccountId: $subaccountId
    ) {
      totalCount
      campaigns {
        ...CampaignFieldsForList
      }
    }
  }
`;

export const LIST_PINNED_CAMPAIGNS = gql`
  ${CAMPAIGN_FIELDS_FOR_LIST}

  query listPinnedCampaigns($subaccountId: ID!) {
    listPinnedCampaigns(subaccountId: $subaccountId) {
      ...CampaignFieldsForList
    }
  }
`;

export const CREATE_CAMPAIGN = gql`
  mutation createCampaign($name: String!, $subaccountId: ID!) {
    createCampaign(name: $name, subaccountId: $subaccountId) {
      id
    }
  }
`;

export const COPY_CAMPAIGN = gql`
  mutation copyCampaign($id: ID!) {
    campaignCopy(id: $id) {
      id
    }
  }
`;

export const ARCHIVE_CAMPAIGN = gql`
  mutation archiveCampaign($id: ID!) {
    campaignArchive(id: $id) {
      id
      status
    }
  }
`;

export const UNARCHIVE_CAMPAIGN = gql`
  mutation unarchiveCampaign($id: ID!) {
    campaignUnarchive(id: $id) {
      id
      status
    }
  }
`;

export const PAUSE_CAMPAIGN = gql`
  mutation pauseCampaign($id: ID!) {
    campaignPause(id: $id) {
      id
      status
    }
  }
`;

export const UNPAUSE_CAMPAIGN = gql`
  mutation unpauseCampaign($id: ID!) {
    campaignUnpause(id: $id) {
      id
      status
    }
  }
`;

export const SET_CAMPAIGN_PINNED = gql`
  mutation setCampaignPinned($id: ID!, $pinned: Boolean!) {
    campaignSetPinned(id: $id, pinned: $pinned) {
      id
      pinned
    }
  }
`;
